import { Flex, IconButton, Image, Img, Link, Skeleton, Text, useBoolean } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { FiMenu } from "react-icons/fi";

import { DrawerMenu } from "@/components/Menu/DrawerMenu";
import { useCart } from "@/contexts/CartContext";
import { useLoading } from "@/contexts/LoadingContext";
import { FreeSearchMobileToHeader } from "../SearchBar/FreeSearch";
import { Logo } from "./Logo";
import { useEffect, useState } from "react";

export function HeaderMobile() {
  const { cartSize } = useCart();
  const [drawerMenu, setDrawerMenu] = useBoolean();
  const router = useRouter();
  const verifyPage = router.route;
  const { ActionIsLoading } = useLoading();
  const { asPath } = useRouter();
  const [isLoading, setIsloading] = useState<boolean>(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsloading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  function handleCart() {
    router.push("/carrinho");
  }
  return (
    <Flex
      position="fixed"
      display={["flex", "none"]}
      zIndex={999}
      direction="column"
      w="full"
      h={"auto"}
      bgColor={"ll-white.main"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Flex
        justifyContent="space-between"
        width="full"
        height="full"
        alignItems="center"
        px={"12px"}
        h={"60px"}
      >
        {isLoading ? (
          <Skeleton w={"30px"} height={"30px"} borderRadius={"5px"} isLoaded={!isLoading} />
        ) : (
          <Img
            cursor={"pointer"}
            onClick={setDrawerMenu.toggle}
            src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/hamburguer.svg"}
          />
        )}

        <Link href="/">
          <Img
            maxH={"30px"}
            src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/ling-long-logo.svg"}
          />
        </Link>

        {isLoading ? (
          <Skeleton w={"30px"} height={"30px"} borderRadius={"5px"} />
        ) : (
          <Flex flexDir={"column"}>
            {cartSize > 0 ? (
              <Flex
                mt={"-12px"}
                ml={"8px"}
                zIndex={1}
                position={"absolute"}
                bgColor={"ll-green.main"}
                minW={"20px"}
                h={"20px"}
                borderRadius={"50px"}
                justifyContent={"center"}
                alignItems={"center"}
                color={"ll-white.main"}
                fontSize={"text1"}
                fontWeight={"600"}
              >
                <Text>{cartSize}</Text>
              </Flex>
            ) : null}

            <Img
              minW={"20px"}
              objectFit={"contain"}
              onClick={handleCart}
              cursor={"pointer"}
              src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/ico-cart.svg"}
            />
          </Flex>
        )}
      </Flex>
      {isLoading ? (
        asPath.includes("/checkout") || asPath === "/carrinho" ? null : (
          <Flex
            borderTop={"1px solid"}
            borderColor={"ll-gray.600"}
            w={"full"}
            h={"50px"}
            justifyContent={"center"}
            alignItems={"center"}
            py={"8px"}
          >
            <Skeleton w={"95%"} height={"40px"} borderRadius={"50px"} />
          </Flex>
        )
      ) : (
        <Flex
          borderTop={"1px solid"}
          borderColor={"ll-gray.600"}
          w={"full"}
          justifyContent={"center"}
          alignItems={"center"}
          py={"8px"}
        >
          <FreeSearchMobileToHeader />
        </Flex>
      )}
      <DrawerMenu
        isOpen={drawerMenu}
        onClose={setDrawerMenu.off}
        placement={"left"}
        DrawerPosition={"mobile"}
      />
    </Flex>
  );
}
